import React from 'react'
import styled, { css } from 'styled-components'
import { overrideColorConfig } from '../../utils/global'

import type { TextProps, VariantMappingType } from './Text.types'
import { textVariant, weightVariant } from './variant'

const variantMapping: VariantMappingType = {
  heading1: 'h1',
  heading2: 'h2',
  heading3: 'h3',
  body: 'p',
  subtitle: 'p',
  caption: 'span',
  small: 'small',
}

const StyledText = styled.span<TextProps>`
  ${(props) =>
    props.strikeThrough &&
    css`
      text-decoration: line-through;
    `}
  width : ${(props) => props.width || 'auto'};
  margin: 0;
  ${overrideColorConfig}
  ${textVariant}
  ${weightVariant}
  display:inline;
  ${(props) =>
    props.lineClamp &&
    css`
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${props.lineClamp};
    `}
`

const Text: React.FC<TextProps> = ({
  variant = 'body',
  weight = 'regular',
  strikeThrough = false,
  ...restProps
}) => (
  <StyledText
    variant={variant}
    as={variantMapping[variant]}
    weight={weight}
    strikeThrough={strikeThrough}
    {...restProps}
  />
)

export default Text
